import { Box, Button, TextField, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const PostHashtagGenerator = ({ hashtags, handleUseHashtag }) => {
  const { t: translate } = useTranslation();

  const useHashtag = () => {
    handleUseHashtag(hashtags);
  };

  return (
    <Box sx={{ mt: 3 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography variant="h6">{translate('post_hashtag_generator.hashtag_generator', 'Hashtag Generator')}</Typography>
        <Button variant="contained" onClick={useHashtag} disabled={!hashtags}>
          {translate('post_hashtag_generator.use_hashtags', 'Use Hashtags')}
        </Button>
      </Box>
      <TextField
        name="hashtags"
        placeholder={translate('post_hashtag_generator.generated_hashtags_placeholder', 'Generated hashtags will appear here')}
        fullWidth
        multiline
        rows={4}
        value={hashtags}
        sx={{ mt: 2 }}
      />
    </Box>
  );
};

export default PostHashtagGenerator;
